import useI18n from "@/hooks/useI18n";

const WHATSAPP_MESSAGE =
  "Olá! Quero consultar minhas passagens no Free Flow com o Sem Parar.";

export const WHATSAPP_HOME_HREF = `https://api.whatsapp.com/send?hl=pt_BR&phone=5511988693758&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export default function WhatsAppHomeButton() {
  const { t } = useI18n();
  const label = t("pages:welcome:payViaWhatsapp");

  return (
    <a
      id="btn-wpp"
      href={WHATSAPP_HOME_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className="fixed bottom-20 right-5 z-[9999] no-underline"
    >
      <div
        id="wpp-box"
        data-testid="wpp-box"
        className="group flex items-center justify-center overflow-hidden rounded-full bg-[#25D366] text-white cursor-pointer w-14 h-14 shadow-md transition-all duration-300 ease-in-out hover:w-[244px] hover:justify-start hover:pl-4 hover:pr-6"
      >
        <span
          id="wpp-icon"
          className="shrink-0 flex items-center justify-center"
        >
          <img
            src="/svg/icon-whatsapp-white.svg"
            alt="WhatsApp"
            width={28}
            height={28}
          />
        </span>
        <span
          id="wpp-text"
          className="max-w-0 whitespace-nowrap font-[Arial,sans-serif] text-base font-bold opacity-0 transition-all duration-200 ease-in-out group-hover:ml-2 group-hover:max-w-[180px] group-hover:opacity-100"
        >
          {label}
        </span>
      </div>
    </a>
  );
}
